import React from 'react';
import Layout from '../core/Layout';
import { Link } from 'react-router-dom'
import { Encabezado } from '../core/Encabezado';

const PREMIOS = [
    { lugar: '1°', texto: 'El primer lugar recibe 3 meses de internet gratis' },
    { lugar: '2°', texto: 'Segundo lugar 3 meses al doble de velocidad.' },
    { lugar: '3°', texto: 'Tercer lugar recibe 50% de descuento en su mensualidad.' },
];

class C1Septiembre2020 extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
    }
    render() {
        return (
            <div>
                <Layout title="Red Itmex - Maestros Septiembre 2020">
                    <section className="paginaItmex">
                        <Encabezado etiqueta="Concurso · Septiembre 2020" titulo="¡Gracias maestr@s y alumn@s!">
                            <div className="concursoDetalle-autor">
                                <img src="/assets/img/logos/logominico.png" alt="" />
                                <span><b>Red Itmex</b> · Septiembre 07, 2020</span>
                            </div>
                        </Encabezado>

                        <div className="concursoDetalle-portada">
                            <img src="/assets/img/concursos/1920x800/c1c2.jpg" alt="Concurso Septiembre 2020" />
                        </div>

                        <div className="concursoDetalle-layout">
                            <article className="legalItmex concursoDetalle-articulo">
                                <p>Sabemos que es difícil quedarse en casa pero queremos darte las gracias por ayudar tanto, gracias porque quedándote en casa estás protegiendo a otras personas del virus, gracias por ser tan valientes y porque haces que todo lo seamos. Hoy queremos demostrar que aunque no estábamos preparados, tú como alumno o maestro te estás adaptando para seguir con el compromiso de aprender o enseñar y queremos mostrarlo a nuestra comunidad.</p>
                                <p>Toma una foto en donde se vea cómo estás recibiendo o dando clases con internet, muestra que estamos siendo fuertes en estos momentos y que un virus no va a parar el compromiso de aprender.</p>

                                <h2>¿Cómo participar?</h2>
                                <p>Toma la foto más <b>creativa</b> que represente la nueva normalidad con clases a distancia.
                                Manda por WhatsApp o <a href="https://www.facebook.com/itmexoficial" target="_blank" rel="noopener noreferrer">Facebook</a> la foto con el nombre al que está registrado tu servicio o número de cliente.
                                Espera la confirmación de nuestro equipo confirmando tu participación al concurso</p>

                                <h2>Términos</h2>
                                <p>Al terminar los meses del premio el usuario vuelve a su plan que tenía contratado, no es transferible ni acumulable, no puede participar en algún otro concurso mientras esté beneficiado de los premios.</p>

                                <img className="concursoDetalle-flyer" src="/assets/img/concursos/flyer.png" alt="Concurso Septiembre 2020" loading="lazy" />
                            </article>

                            <aside className="concursoDetalle-lateral">
                                <div className="concursoDetalle-tarjeta">
                                    <h2 className="promosItmex-grupo-titulo"><i className="fas fa-trophy"></i>Premios</h2>
                                    <ul className="concursoDetalle-premios">
                                        {PREMIOS.map(p => (
                                            <li key={p.lugar}>
                                                <span className="beneficiosNivel-numero">{p.lugar}</span>
                                                {p.texto}
                                            </li>
                                        ))}
                                    </ul>
                                    <p className="concursoDetalle-nota">Todos los participantes tendrán un 5% de descuento en su siguiente pago.</p>
                                    <div className="concursoDetalle-fechas">
                                        <i className="far fa-calendar"></i>
                                        <span>Puedes mandar tu foto desde el 7 al 12 de septiembre. Las fotos de los ganadores serán mostradas el 14 de septiembre en Facebook y WhatsApp.</span>
                                    </div>
                                </div>
                                <div className="concursoDetalle-tarjeta concursoDetalle-autorTarjeta">
                                    <img src="/assets/img/logos/logominico.png" alt="" />
                                    <small>Escrito por</small>
                                    <Link to="/nosotros"><b>Red Itmex</b></Link>
                                    <p>Estamos en la misión de proveer servicio de internet a las zonas más remotas, acercar y enseñar tecnologías de vanguardia a las personas que construyen el futuro de nuestras comunidades.</p>
                                </div>
                                <Link className="concursoDetalle-volver" to="/concursos"><i className="fas fa-arrow-left"></i> Todos los concursos</Link>
                            </aside>
                        </div>
                    </section>
                </Layout>
            </div >
        )
    }
};
export default C1Septiembre2020;
